import fetchAPI from '../fetchAPI';

export const callGetTablePreferences = async (
  tableName: string
): Promise<iResponse<TablePrefs | null>> => {
  const response: iResponse<TablePrefs | null> = await fetchAPI({
    method: `GET`,
    route: `user/preferences/tables/${encodeURIComponent(tableName)}`
  });

  return response;
};

export default callGetTablePreferences;
